import React from 'react';
import cn from "./../../../../lib/bem";
import img_persona from './../../../../assets/svg/img_persona_exito.svg'
import ico_abuelita from './../../../../assets/svg/ico_abuelita.svg';
import ico_mapamundi from './../../../../assets/svg/ico_mapamundi.svg';
import ico_medalla from './../../../../assets/svg/ico_medalla.svg';
import CardComponent from './../../../../components/card/card_component';
import ico_documento from './../../../../assets/svg/ico_documento.svg';

import './seccion_caracteristicas.scss';

const SeccionCaracteristicas = () => {

    const classes = cn("seccionCaracteristicas");

    return ( 
        <div className={classes()}>
            <div className={classes('mobileCaracteristicasDiv')}>
                <div className={classes('mobileCaracteristicas')}>
                    <p className={classes('titleCaracteristicas')}><b>¿Por qué elegirnos?</b></p>
                    <img className={classes('imgCaracteristicas')} src={img_persona} alt="icono persona"/>

                    <CardComponent
                        key={3} 
                        icono={ico_documento}
                        title={"Respaldo Financiero"}
                        desc={["Pacífico cuenta con la más alta calificación crediticia posible en el mercado peruano.¹"]}
                    />
                    <CardComponent
                        key={5} 
                        icono={ico_mapamundi}
                        title={"Somos parte de Credicorp"}
                        desc={['Único grupo peruano dentro de las 1,000 compañías más valiosas del mundo.²']}
                    />
                    <CardComponent
                        key={4} 
                        icono={ico_medalla}
                        title={"Mejor aseguradora del Perú durante 2 años"}
                        desc={['Primer puesto por segundo año consecutivo en la categoría "Mejor compañía de Seguros y Reaseguros en Perú 2023".³']}
                    /> 
                    <CardComponent
                        key={6} 
                        icono={ico_abuelita}
                        title={"Número de asegurados"}
                        desc={"Más de 5 millones de personas protegidas por nosotros."}
                    /> 

                </div>
                <div className={classes('desktopCaracteristicas')}>
                    <div>
                        <p className={classes('titleCaracteristicas')}><b>¿Por qué elegirnos?</b></p>
                        <div className={classes('tableCaracteristicas')}>
                            <div>
                                <CardComponent
                                    key={31} 
                                    icono={ico_documento}
                                    title={"Respaldo Financiero"}
                                    desc={["Pacífico cuenta con la más alta calificación crediticia posible en el mercado peruano.¹"]}
                                />
                            </div>
                            <div>
                                <img className={classes('imgCaracteristicas')} src={img_persona} alt="icono persona"/>
                            </div>
                            <div>
                                <CardComponent
                                    key={41} 
                                    icono={ico_medalla}
                                    title={"Mejor aseguradora del Perú durante 2 años"}
                                    desc={['Primer puesto por segundo año consecutivo en la categoría "Mejor compañía de Seguros y Reaseguros en Perú 2023".³']}
                                /> 
                            </div>
                        </div>
                        <div className={classes('table2Caracteristicas')}>
                            <CardComponent
                                key={51} 
                                icono={ico_mapamundi}
                                title={"Somos parte de Credicorp"}
                                desc={['Único grupo peruano dentro de las 1,000 compañías más valiosas del mundo.²']}
                            />
                            <CardComponent
                                key={62} 
                                icono={ico_abuelita}
                                title={"Número de asegurados"}
                                desc={"Más de 5 millones de personas protegidas por nosotros."}
                            /> 
                        </div>
                    </div>
                </div>
                <br/>
                <p className={classes('declaimerCaracteristicas')}>1. Más información <a target='_blank' href='https://www.pacifico.com.pe/nosotros#calificacion-riesgo' rel='noreferrer'>aquí</a></p>
                <p className={classes('declaimerCaracteristicas')}>2. Puesto Nº 849 en Forbes . Actualizado a agosto 2024 <a target='_blank' href='https://www.forbes.com/companies/credicorp/?list=global2000&sh=4d221e232598' rel='noreferrer'>Ver detalle</a></p>
                <p className={classes('declaimerCaracteristicas')}>3. Otorgado por Finance Derivative. Conoce más detalles <a target='_blank' href='https://www.financederivative.com/winners-list-2023/' rel='noreferrer'>aquí</a></p>
                <br/><br/>
            </div>
        </div>
    );
}
 
export default SeccionCaracteristicas;